/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'
import type * as AppBskyActorDefs from '../../../app/bsky/actor/defs.js'
import type * as ComAtprotoLabelDefs from '../../../com/atproto/label/defs.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'chat.bsky.actor.defs'

export type MemberRole = 'owner' | 'standard' | (string & {})

export interface ProfileViewBasic {
  $type?: 'chat.bsky.actor.defs#profileViewBasic'
  did: string
  handle: string
  displayName?: string
  avatar?: string
  associated?: AppBskyActorDefs.ProfileAssociated
  viewer?: AppBskyActorDefs.ViewerState
  labels?: ComAtprotoLabelDefs.Label[]
  createdAt?: string
  /** Set to true when the actor cannot actively participate in conversations */
  chatDisabled?: boolean
  verification?: AppBskyActorDefs.VerificationState
  kind?:
    | $Typed<DirectConvoMember>
    | $Typed<GroupConvoMember>
    | $Typed<PastGroupConvoMember>
    | { $type: string }
}

const hashProfileViewBasic = 'profileViewBasic'

export function isProfileViewBasic<V>(v: V) {
  return is$typed(v, id, hashProfileViewBasic)
}

export function validateProfileViewBasic<V>(v: V) {
  return validate<ProfileViewBasic & V>(v, id, hashProfileViewBasic)
}

export interface DirectConvoMember {
  $type?: 'chat.bsky.actor.defs#directConvoMember'
}

const hashDirectConvoMember = 'directConvoMember'

export function isDirectConvoMember<V>(v: V) {
  return is$typed(v, id, hashDirectConvoMember)
}

export function validateDirectConvoMember<V>(v: V) {
  return validate<DirectConvoMember & V>(v, id, hashDirectConvoMember)
}

/** A current group convo member. */
export interface GroupConvoMember {
  $type?: 'chat.bsky.actor.defs#groupConvoMember'
  addedBy?: ProfileViewBasic
  role: MemberRole
}

const hashGroupConvoMember = 'groupConvoMember'

export function isGroupConvoMember<V>(v: V) {
  return is$typed(v, id, hashGroupConvoMember)
}

export function validateGroupConvoMember<V>(v: V) {
  return validate<GroupConvoMember & V>(v, id, hashGroupConvoMember)
}

/** A past group convo member. */
export interface PastGroupConvoMember {
  $type?: 'chat.bsky.actor.defs#pastGroupConvoMember'
}

const hashPastGroupConvoMember = 'pastGroupConvoMember'

export function isPastGroupConvoMember<V>(v: V) {
  return is$typed(v, id, hashPastGroupConvoMember)
}

export function validatePastGroupConvoMember<V>(v: V) {
  return validate<PastGroupConvoMember & V>(v, id, hashPastGroupConvoMember)
}
